export default "# DataTable 数据表格\r\n\r\n通用数据表格。\r\n\r\n封装了远程/本地分页、远程/本地加载、去抖、时序、数据驱动, 动态列。\r\n\r\n## 何时使用\r\n\r\n- 所有的查询表格。";